// import React, {useEffect, useState} from "react";
// import {
//     Form,
//     HyperLink,
//     notification,
// } from "../../components/Elements/appUtils";
// import {KotType, category, subCategoryType} from "../../components/_utils/appUtils";
// import {FetchCatgory} from "../variants/actions";
// import PageHeader from "../../components/Elements/pageHeader";
// import {useDispatch} from "react-redux";
// import {GetEachFormFields} from "../../components/_utils/formUtils";
// import _ from "lodash";
// import {useNavigate} from "react-router-dom";
// import {singleCategoryFxn, updateCategoryFxn} from "./actions";

// const EditCategory = (props) => {
//     const [formData, setFormData] = useState({
//         name: "",
//     });
//     const [categoryFile, setCategoryFile] = useState("");

//     const handleFileChange = (e) => {
//         const file = e.files[0];
//         setCategoryFile(file);
//     };
//     const [allCategory, setAllCategory] = useState([]);
//     const [mainCategoryIndex, setMainCategoryIndex] = useState("");
//     let dispatch = useDispatch();
//     let navigate = useNavigate();
//     const [categoryId, setcategoryId] = useState("");
//     useEffect(() => {
//         checkcategoryId();
//     }, []);

//     let id;

//     const checkcategoryId = async () => {
//         let searchParams = new URLSearchParams(window.location.search);
//         id = searchParams.get("_id");
//         if (id) {
//             getSinglecategory(id);
//             setcategoryId(id);
//         }
//     };
//     const getSinglecategory = async (id) => {
//         let {data, success} = await dispatch(singleCategoryFxn(id));
//         if (success) {
//             setTimeout(() => {
//                 props.form.setFieldsValue({
//                     name: data.name,
//                     menu: data.menu,
//                     categoryType: data.categoryType,
//                     subCategory: data.subCategory,
//                 });
//             }, 300);
//         }
//     };
//     useEffect(() => {
//         handleState();
//     }, []);

//     const handleState = async () => {
//         let x = await FetchCatgory();
//         setAllCategory(x.data);
//     };

//     const handleSubmit = (e) => {
//         const {form} = props;
//         e.preventDefault();

//         form.validateFields(async (err, valData) => {
//             if (!err) {
//                 valData._id = categoryId;
//                 valData.mainCategoryIndex = mainCategoryIndex;
//                 let fd = new FormData();
//                 fd.append("obj", JSON.stringify(valData));
//                 if (categoryFile && categoryFile.name) {
//                     fd.append("categoryFile", categoryFile);
//                 }
//                 let x = await dispatch(updateCategoryFxn(fd));
//                 if (x && x.success) {
//                     navigate("/addCategory");
//                 }
//             } else {
//                 if (err.name) {
//                     notification.warning({
//                         message: `Please enter Name`,
//                     });
//                     return;
//                 }

//                 notification.warning({
//                     message: "Fill All Required Fields",
//                 });
//             }
//         });
//     };
//     let inputTypes = {
//         fields: [
//             {
//                 key: "menu",
//                 label: "Main Category",
//                 span: "col-md-4",
//                 type: "select",
//                 options: category,
//                 keyAccessor: (x) => x.name,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (selectedOption) => {
//                     const [key, index] = selectedOption.split("_");
//                     console.log(key, index, "index");
//                     let findIndex = _.find(category, (item) => {
//                         return item.name == selectedOption;
//                     });
//                     setMainCategoryIndex(findIndex.index);
//                     props.form.setFieldsValue({
//                         menu: key,
//                         mainCategoryIndex: findIndex.index,
//                     });
//                 },
//             },
//             {
//                 key: "name",
//                 label: "Name *",
//                 span: "col-md-4",
//                 // placeholder: "Name",
//             },
//             {
//                 key: "categoryType",
//                 label: "Category type",
//                 span: "col-md-3",
//                 type: "select",
//                 options: KotType,
//                 keyAccessor: (x) => x.key,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         categoryType: x,
//                     });
//                 },
//             },
//             {
//                 key: "subCategory",
//                 label: "Sub Category",
//                 span: "col-md-3",
//                 type: "select",
//                 options: subCategoryType,
//                 hidden: !(props.form.getFieldValue('categoryType') == 'kitchen'),
//                 required: (props.form.getFieldValue('categoryType') == 'kitchen'),
//                 keyAccessor: (x) => x.key,
//                 valueAccessor: (x) => `${x.name}`,
//                 onChange: (x) => {
//                     props.form.setFieldsValue({
//                         subCategory: x,
//                     });
//                 },
//             },
//             {
//                 key: "categoryFile",
//                 label: "Category File",
//                 required: false,
//                 type: "file",
//                 fileName: categoryFile,
//                 onChange: ({target}) => {
//                     handleFileChange(target);
//                 },
//                 span: "col-md-4",
//             },
//         ],
//     };

//     return (
//         <>
//             <PageHeader title={"Edit Category"}>
//                 <div className="card">
//                     <div className="card-body">
//                         <Form onSubmit={handleSubmit}>
//                             <div className="form-elements-wrapper">
//                                 <div className={"row"}>
//                                     {inputTypes.fields.map((item, key) => {
//                                         return !item.hidden ? (
//                                             <div
//                                                 className={`${item.span ? item.span : "col-md-6"}`}
//                                                 key={key}
//                                             >
//                                                 <GetEachFormFields {...props.form} item={item}/>
//                                             </div>
//                                         ) : null;
//                                     })}
//                                 </div>
//                             </div>

//                             <button type="submit" className="btn btn-primary">
//                                 Submit
//                             </button>
//                             <HyperLink
//                                 className=" ms-4 btn btn-danger"
//                                 link={"/addCategory"}
//                             >
//                                 Cancel
//                             </HyperLink>
//                         </Form>
//                     </div>
//                 </div>
//             </PageHeader>
//         </>
//     );
// };

// export default Form.create()(EditCategory);




// import React, { useEffect, useState } from "react";
// import {
//   Form,
//   HyperLink,
//   notification
// } from "../../components/Elements/appUtils";
//
// import PageHeader from "../../components/Elements/pageHeader";
// import { GetEachFormFields } from "../../components/_utils/formUtils";
// import { KotType, subCategoryType } from "../../components/_utils/appUtils";
//
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
//
// import { singleCategoryFxn, updateCategoryFxn } from "./actions";
//
// import { appAxios as axios } from "../../request";
// import { getToken } from "../../request";
//
// import { getMainMenuUrl } from "../mainmenu/api";
// import { getMainCategoryUrl } from "../maincategory/api";
//
// const EditCategory = (props) => {
//
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//
//   const [categoryId, setCategoryId] = useState("");
//
//   const [mainMenus, setMainMenus] = useState([]);
//   const [mainCategories, setMainCategories] = useState([]);
//
//   const [categoryFile, setCategoryFile] = useState("");
//   const yesNoOptions = [
//   { key: true, name: "Yes" },
//   { key: false, name: "No" }
// ];
//
//   /* ================================
//       LOAD MAIN MENUS
//   ================================ */
//
//   const loadMainMenus = async () => {
//     try {
//       const res = await axios.get(getMainMenuUrl(), getToken());
//
//       if (res.data.success) {
//         setMainMenus(res.data.data);
//       }
//
//     } catch (err) {
//       console.log(err);
//     }
//   };
//
//   /* ================================
//       LOAD MAIN CATEGORIES
//   ================================ */
//
//   const loadMainCategories = async (menuId) => {
//     try {
//
//       const res = await axios.get(
//         getMainCategoryUrl(),
//         {
//           ...getToken(),
//           params: { mainMenuId: menuId }
//         }
//       );
//
//       if (res.data.success) {
//         setMainCategories(res.data.data);
//       }
//
//     } catch (err) {
//       console.log(err);
//     }
//   };
//
//   /* ================================
//       FILE CHANGE
//   ================================ */
//
//   const handleFileChange = (e) => {
//     const file = e.files[0];
//     setCategoryFile(file);
//   };
//
//   /* ================================
//       GET CATEGORY ID
//   ================================ */
//
//   useEffect(() => {
//
//     const params = new URLSearchParams(window.location.search);
//     const id = params.get("_id");
//
//     if (id) {
//       setCategoryId(id);
//       getSingleCategory(id);
//     }
//
//     loadMainMenus();
//
//   }, []);
//
//   /* ================================
//       GET SINGLE CATEGORY
//   ================================ */
//
//   const getSingleCategory = async (id) => {
//
//     const { data, success } = await dispatch(singleCategoryFxn(id));
//
//     if (success) {
//
//       const category = data;
//
//       await loadMainCategories(category.mainMenuId);
//
//       setTimeout(() => {
//
//         // props.form.setFieldsValue({
//         //   mainMenuId: category.mainMenuId,
//         //   mainCategoryId: category.mainCategoryId,
//         //   name: category.name,
//         //   categoryType: category.categoryType,
//         //   subCategory: category.subCategory
//         // });
//        props.form.setFieldsValue({
//   mainMenuId: category.mainMenuId,
//   mainCategoryId: category.mainCategoryId,
//   name: category.name,
//   categoryType: category.categoryType,
//   subCategory: category.subCategory,
//   gst: category.gst,
//   discount: category.discount
// });
//
//       }, 300);
//
//     }
//
//   };
//
//   /* ================================
//       SUBMIT
//   ================================ */
//
//   const handleSubmit = (e) => {
//
//     const { form } = props;
//
//     e.preventDefault();
//
//     form.validateFields(async (err, valData) => {
//
//       if (!err) {
//
//         valData._id = categoryId;
//
//         let fd = new FormData();
//
//         fd.append("obj", JSON.stringify(valData));
//
//         if (categoryFile && categoryFile.name) {
//           fd.append("categoryFile", categoryFile);
//         }
//
//         const resp = await dispatch(updateCategoryFxn(fd));
//
//         if (resp && resp.success) {
//
//           notification.success({
//             message: "Category Updated Successfully"
//           });
//
//           navigate("/addCategory");
//
//         }
//
//       } else {
//
//         notification.warning({
//           message: "Please fill required fields"
//         });
//
//       }
//
//     });
//
//   };
//   const categoryType = props.form.getFieldValue("categoryType") || "";
//
//   /* ================================
//       FORM FIELDS
//   ================================ */
//
//   let inputTypes = {
//
//     fields: [
//
//       /* MAIN MENU */
//
//       {
//         key: "mainMenuId",
//         label: "Main Menu",
//         span: "col-md-3",
//         type: "select",
//         options: mainMenus,
//         keyAccessor: (x) => x._id,
//         valueAccessor: (x) => x.mainMenuName.toUpperCase(),
//         onChange: (value) => {
//
//           props.form.setFieldsValue({
//             mainMenuId: value,
//             mainCategoryId: undefined
//           });
//
//           loadMainCategories(value);
//
//         }
//       },
//
//       /* MAIN CATEGORY */
//
//       {
//         key: "mainCategoryId",
//         label: "Main Category",
//         span: "col-md-3",
//         type: "select",
//         options: mainCategories,
//         keyAccessor: (x) => x._id,
//         valueAccessor: (x) => x.mainCategoryName,
//         onChange: (value) => {
//
//           props.form.setFieldsValue({
//             mainCategoryId: value
//           });
//
//         }
//       },
//
//       /* NAME */
//
//       {
//         key: "name",
//         label: "Name *",
//         span: "col-md-3"
//       },
//
//       /* CATEGORY TYPE */
//
//       {
//         key: "categoryType",
//         label: "Category Type",
//         span: "col-md-3",
//         type: "select",
//         options: KotType,
//         keyAccessor: (x) => x.key,
//         valueAccessor: (x) => `${x.name}`,
// onChange: (value) => {
//
//   props.form.setFieldsValue({
//     categoryType: value,
//     subCategory: undefined
//   });
//
// },
//       },
//
//       /* SUB CATEGORY */
//
//     {
//   key: "subCategory",
//   label: "Sub Category",
//   span: "col-md-3",
//   type: "select",
//   options: subCategoryType,
//   hidden: categoryType !== "kitchen",
//   required: categoryType === "kitchen",
//   keyAccessor: (x) => x.key,
//   valueAccessor: (x) => `${x.name}`,
//   onChange: (x) => {
//
//     props.form.setFieldsValue({
//       subCategory: x
//     });
//
//   }
// },
//       /* GST */
//
// {
//   key: "gst",
//   label: "GST",
//   span: "col-md-3",
//   type: "select",
//   options: yesNoOptions,
//   keyAccessor: (x) => x.key,
//   valueAccessor: (x) => x.name,
//   onChange: (value) => {
//
//     props.form.setFieldsValue({
//       gst: value
//     });
//
//   }
// },
//
// /* DISCOUNT */
//
// {
//   key: "discount",
//   label: "Discount",
//   span: "col-md-3",
//   type: "select",
//   options: yesNoOptions,
//   keyAccessor: (x) => x.key,
//   valueAccessor: (x) => x.name,
//   onChange: (value) => {
//
//     props.form.setFieldsValue({
//       discount: value
//     });
//
//   }
// },
//
//       /* FILE */
//
//       {
//         key: "categoryFile",
//         label: "Category File",
//         required: false,
//         type: "file",
//         fileName: categoryFile,
//         onChange: ({ target }) => {
//           handleFileChange(target);
//         },
//         span: "col-md-3"
//       }
//
//     ]
//
//   };
//
//   /* ================================
//       UI
//   ================================ */
//
//   return (
//
//     <PageHeader title={"Edit Category"}>
//
//       <div className="card">
//         <div className="card-body">
//
//           <Form onSubmit={handleSubmit}>
//
//             <div className="form-elements-wrapper">
//
//               <div className="row">
//
//                 {inputTypes.fields.map((item, key) =>
//                   !item.hidden ? (
//
//                     <div
//                       className={item.span ? item.span : "col-md-6"}
//                       key={key}
//                     >
//
//                       <GetEachFormFields
//                         {...props.form}
//                         item={item}
//                       />
//
//                     </div>
//
//                   ) : null
//                 )}
//
//               </div>
//
//             </div>
//
//             <button type="submit" className="btn btn-primary">
//               Update
//             </button>
//
//             <HyperLink
//               className="ms-4 btn btn-danger"
//               link={"/addCategory"}
//             >
//               Cancel
//             </HyperLink>
//
//           </Form>
//
//         </div>
//       </div>
//
//     </PageHeader>
//
//   );
//
// };
//
// export default Form.create()(EditCategory);


import React, { useEffect, useState } from "react";
import { Form, Drawer, notification } from "../../components/Elements/appUtils";
import { GetEachFormFields } from "../../components/_utils/formUtils";
import { KotType, subCategoryType } from "../../components/_utils/appUtils";
import { useDispatch } from "react-redux";
import { singleCategoryFxn, updateCategoryFxn } from "./actions";
import { appAxios as axios } from "../../request";
import { getToken } from "../../request";
import { getMainMenuUrl } from "../mainmenu/api";
import { getMainCategoryUrl } from "../maincategory/api";

function EditCategory(props) {
  const { visible, editData, onClose, reloadTable, form } = props;

  const dispatch = useDispatch();

  const [categoryId, setCategoryId] = useState("");
  const [mainMenus, setMainMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [categoryFile, setCategoryFile] = useState("");
  const [fileReset, setFileReset] = useState(0);
  const [selectedCategoryType, setSelectedCategoryType] = useState("");

  const yesNoOptions = [
    { key: true, name: "Yes" },
    { key: false, name: "No" },
  ];

  const categoryType = props.form.getFieldValue("categoryType") || "";

  /* ================================
      LOAD MAIN MENUS
  ================================ */
  const loadMainMenus = async () => {
    try {
      const res = await axios.get(getMainMenuUrl(), getToken());

      if (res.data.success) {
        setMainMenus(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* ================================
      LOAD MAIN CATEGORIES
  ================================ */
  const loadMainCategories = async (menuId) => {
    try {
      const res = await axios.get(getMainCategoryUrl(), {
        ...getToken(),
        params: { mainMenuId: menuId },
      });

      if (res.data.success) {
        const realMainCategories = (res.data.data || []).filter(
            (item) => item.source !== "legacy"
        );
        setMainCategories(realMainCategories);
      }
    } catch (err) {
      console.log(err);
    }
  };


  /* ================================
      FILE CHANGE
  ================================ */
  const handleFileChange = (e) => {
    const file = e.files[0];
    console.log("SELECTED FILE =>", file);
    setCategoryFile(file);
  };

  /* ================================
      LOAD ON DRAWER OPEN
  ================================ */
  useEffect(() => {
    if (visible) {
      loadMainMenus();
    }
  }, [visible]);

  useEffect(() => {
    if (visible && editData?._id) {
      setCategoryId(editData._id);
      getSingleCategory(editData._id);
    }
  }, [visible, editData?._id]);

  /* ================================
      GET SINGLE CATEGORY
  ================================ */
  const getSingleCategory = async (id) => {
    const { data, success } = await dispatch(singleCategoryFxn(id));

    if (success) {
      const category = data;

      await loadMainCategories(category.mainMenuId);
      setSelectedCategoryType(category.categoryType || "");

      setTimeout(() => {
        props.form.setFieldsValue({
          mainMenuId: category.mainMenuId,
          mainCategoryId: category.mainCategoryId,
          name: category.name,
          categoryType: category.categoryType,
          subCategory: category.subCategory,
          gst: category.gst,
          discount: category.discount,
        });
      }, 300);

      setCategoryFile("");
      setFileReset((prev) => prev + 1);
    }
  };

  /* ================================
      RESET + CLOSE
  ================================ */
  const resetAndClose = () => {
    props.form.resetFields();
    setCategoryId("");
    setCategoryFile("");
    setMainCategories([]);
    setSelectedCategoryType("");
    setFileReset((prev) => prev + 1);
    onClose();
  };

  /* ================================
      SUBMIT
  ================================ */
  const handleSubmit = (e) => {
    const { form } = props;
    e.preventDefault();

    form.validateFields(async (err, valData) => {
      if (!err) {
        valData._id = categoryId;
        if (valData.categoryType !== "kitchen") {
          valData.subCategory = "";
        }

        let fd = new FormData();
        fd.append("obj", JSON.stringify(valData));

        if (categoryFile && categoryFile.name) {
          fd.append("categoryFile", categoryFile);
        }

        const resp = await dispatch(updateCategoryFxn(fd));

        if (resp && resp.success) {
          notification.success({
            message: "Category Updated Successfully",
          });

          resetAndClose();
          reloadTable();
        }
      } else {
        notification.warning({
          message: "Please fill required fields",
        });
      }
    });
  };

  /* ================================
      FORM FIELDS
  ================================ */
  let inputTypes = {
    fields: [
      {
        key: "mainMenuId",
        label: "Main Menu",
        span: "col-md-12",
        type: "select",
        options: mainMenus,
        keyAccessor: (x) => x._id,
        valueAccessor: (x) => x.mainMenuName.toUpperCase(),
        onChange: async (value) => {
          props.form.setFieldsValue({
            mainMenuId: value,
            mainCategoryId: undefined,
          });

          await loadMainCategories(value);
        },
      },
      {
        key: "mainCategoryId",
        label: "Main Category",
        span: "col-md-12",
        type: "select",
        options: mainCategories,
        keyAccessor: (x) => x._id,
        valueAccessor: (x) => x.mainCategoryName,
        onChange: (value) => {
          props.form.setFieldsValue({
            mainCategoryId: value,
          });
        },
      },
      {
        key: "name",
        label: "Name *",
        span: "col-md-12",
      },
      {
        key: "categoryType",
        label: "Category Type",
        span: "col-md-12",
        type: "select",
        options: KotType,
        keyAccessor: (x) => x.key,
        valueAccessor: (x) => `${x.name}`,
        // onChange: (value) => {
        //   props.form.setFieldsValue({
        //     categoryType: value,
        //     subCategory: undefined,
        //   });
        // },
        onChange: (value) => {
          setSelectedCategoryType(value);
          props.form.setFieldsValue({
            categoryType: value,
            subCategory: undefined,
          });
        },
      },
      {
        key: "subCategory",
        label: "Sub Category",
        span: "col-md-12",
        type: "select",
        options: subCategoryType,
        // hidden: categoryType !== "kitchen",
        // required: categoryType === "kitchen",
        hidden: selectedCategoryType !== "kitchen",
        required: selectedCategoryType === "kitchen",
        keyAccessor: (x) => x.key,
        valueAccessor: (x) => `${x.name}`,
        onChange: (value) => {
          props.form.setFieldsValue({
            subCategory: value,
          });
        },
      },
      {
        key: "gst",
        label: "GST",
        span: "col-md-12",
        type: "select",
        options: yesNoOptions,
        keyAccessor: (x) => x.key,
        valueAccessor: (x) => x.name,
        onChange: (value) => {
          props.form.setFieldsValue({
            gst: value,
          });
        },
      },
      {
        key: "discount",
        label: "Discount",
        span: "col-md-12",
        type: "select",
        options: yesNoOptions,
        keyAccessor: (x) => x.key,
        valueAccessor: (x) => x.name,
        onChange: (value) => {
          props.form.setFieldsValue({
            discount: value,
          });
        },
      },
      {
        key: "categoryFile",
        label: "Category File",
        required: false,
        type: "file",
        fileName: categoryFile,
        onChange: ({ target }) => {
          handleFileChange(target);
        },
        span: "col-md-12",
      },
    ],
  };

  /* ================================
      UI
  ================================ */
  return (
      <Drawer
          title="Edit Category"
          placement="right"
          width={"50%"}
          visible={visible}
          onClose={resetAndClose}
          destroyOnClose
      >
        <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              minHeight: "100%",
            }}
        >
          <Form onSubmit={handleSubmit}>
            <div className="row">
              {inputTypes.fields.map((item, key) =>
                  !item.hidden ? (
                      <div
                          className={item.span ? item.span : "col-md-6"}
                          key={
                            item.key === "categoryFile"
                                ? `edit-categoryFile-${fileReset}`
                                : key
                          }
                      >
                        <GetEachFormFields {...props.form} item={item} />
                      </div>
                  ) : null
              )}
            </div>

            <button type="submit" className="btn btn-primary">
              Update
            </button>

            <button
                type="button"
                className="btn btn-danger ms-2"
                onClick={resetAndClose}
            >
              Cancel
            </button>
          </Form>
        </div>
      </Drawer>
  );
}

export default Form.create()(EditCategory);
